import { isElement } from '../../utilities/nodes/elements/isElement.mjs';

// Set a list of element types to inline/void
const withInlineVoidTypes = (editor, plugins) => {
  const {
    isInline
  } = editor;
  const {
    isVoid
  } = editor;
  const {
    voidTypes,
    inlineTypes
  } = plugins.reduce((acc, plugin) => {
    return {
      inlineTypes: plugin.inlineTypes ? [...acc.inlineTypes, ...plugin.inlineTypes] : acc.inlineTypes,
      voidTypes: plugin.voidTypes ? [...acc.voidTypes, ...plugin.voidTypes] : acc.voidTypes
    };
  }, {
    voidTypes: [],
    inlineTypes: []
  });
  editor.isInline = element => isElement(element) && inlineTypes.includes(element.type) ? true : isInline(element);
  editor.isVoid = element => isElement(element) && voidTypes.includes(element.type) ? true : isVoid(element);
  return editor;
};

export { withInlineVoidTypes };
